document.addEventListener("turbo:load", function() {
  $('[data-confirm]').on('click', function() {
    return confirm($(this).data('confirm'));
  });
  
});